import VirtualTourLeftPart from '../../../components/VirtualTourPage/VirtualTourLeftPart/VirtualTourLeftPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(VirtualTourLeftPart);
